<template>
  <div class="mt-2 flex overflow-hidden flex-grow">
    <div class="overflow-hidden flex flex-col pb-4 flex-grow bg-trader-gray mr-2">

      <!-- Go back -->
      <div class="w-full h-10">
        <CGoBack/>
      </div>

      <!-- Bearbeitung Weißer hintergrund -->
      <div class="flex-grow overflow-auto px-10 text-center justify-center flex">
        <div class="overflow-hidden bg-white rounded p-10 max-w-[1000px] flex-grow flex flex-col">
          <div class="flex flex-col overflow-hidden flex-grow ">

            <!-- Artikel Information -->
            <div>
              <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
                <div class="w-full bg-primary p-2 rounded">
                  <span class="text-xl">Artikel Information</span>
                </div>
              </div>
              <div class="flex mt-2 text-left w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Artikel Nummer:</span>
                <input class="border p-2 rounded w-3/4" v-model="articleNumber" data-ui="input-article-number">
              </div>
              <div class="flex mt-2 text-left w-full overflow-auto">
                <span class="bg-primary w-1/4 p-2 rounded">TeamID:</span>
                <select class="border p-2 rounded w-3/4" v-model="teamId" data-ui="select-team-id">
                  <option :data-ui="section.teamIcon" v-for="section in shoppingSections" :key="section.id"
                          :value="section.id">
                    {{ section.teamIcon }} - {{ section.name }}
                  </option>
                </select>
              </div>
              <div class="flex mt-2 text-left w-full">
                <span class="bg-primary w-1/4 p-2 rounded">ProductID:</span>
                <input class="border p-2 rounded w-3/4" v-model="productId">
              </div>
            </div>

            <!-- Artikel Formular Header -->
            <div class="flex items-center justify-between h-10 my-4 w-full rounded">
              <div class="w-full bg-primary p-2 rounded">
                <span class="text-xl">Artikel Formular</span>
              </div>
            </div>

            <!-- Filter Bereich -->
            <div class="w-full mb-6 p-1  bg-trader-gray rounded-lg  ">
              <div class="flex flex-row items-center justify-between gap-4">
                <!-- Formular Auswahl -->
                <div class="flex flex-wrap gap-2">
                  <button
                      v-for="formular in formularNames"
                      :key="formular.idForm"
                      @click="toggleButton(formular.idForm)"
                      class="px-4 py-2 rounded-md text-trader-text transition-all duration-200 border"
                      :class="{
                        'bg-trader-blue border-trader-blue shadow-sm': selectedId === formular.idForm,
                        'bg-white dark:border-gray-700 dark:hover:bg-gray-700 border-gray-300 hover:bg-gray-50': selectedId !== formular.idForm
                      }"
                  >
                    {{ formular.name }}
                  </button>
                  <input
                      class="px-4 py-2 rounded-md border border-gray-300 focus:ring-2 focus:ring-primary focus:border-transparent"
                      v-model="searchTerm"
                      placeholder="Felder durchsuchen..."
                  >
                  <button @click="clearSearch" class="px-4 py-2 rounded-md bg-white text-trader-text hover:bg-gray-50 border border-gray-300 dark:border-gray-700 dark:hover:bg-gray-700">
                    Reset
                  </button>
                </div>

                <!-- Nur gefüllte Felder Button -->
                <button
                    @click="toggleShowOnlyFilled"
                    :class="[
                    'px-4 py-2 rounded-md transition-all duration-200 whitespace-nowrap text-trader-text',
                    showOnlyFilled
                      ? 'bg-primary text-trader-text shadow-sm'
                      : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 dark:border-gray-700 dark:hover:bg-gray-700'
                  ]"
                >
                  <span v-if="showOnlyFilled">✓ Nur gefüllte Felder</span>
                  <span v-else>Nur gefüllte Felder</span>
                </button>


              </div>

            </div>

            <!-- Formular Felder -->
            <div class="flex-grow  overflow-auto">
              <div class="space-y-2">
                <!-- DEBUG INFO - Temporär zum Debuggen -->
                <div v-if="!selectedId" v-for="(field, index) in filteredFields" :key="field.fieldId || index" class="flex w-full">
                  <span class="bg-primary w-1/4 p-2 rounded-l text-trader-text"> {{ field.fieldName }}</span>
                  <input
                      class="border border-l-0 p-2 flex rounded-r flex-grow focus:ring-2 focus:ring-primary focus:border-transparent"
                      :data-ui="'input-'+ field.fieldName"
                      v-model="field.fieldValue"
                  >
                </div>
                <div v-else v-for="(form, index) in filteredFormular" :key="form.id || index" class="flex w-full">
                  <span class="bg-primary w-1/4 p-2 rounded-l text-trader-text">{{ form.field }}</span>
                  <input
                      class="border border-l-0 p-2 rounded-r w-3/4 focus:ring-2 focus:ring-primary focus:border-transparent"
                      :data-ui="'input-'+ form.form"
                      v-model="form.fieldValue"
                  >
                </div>
              </div>

              <!-- Nachricht wenn keine Felder gefunden -->
              <div v-if="filteredFields.length === 0"
                   class="w-full text-center text-gray-500 mt-8 p-8 bg-gray-50 rounded-lg">
                <svg class="mx-auto h-12 w-12 text-gray-400 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                <p class="text-lg">Keine Felder gefunden</p>
                <p class="text-sm mt-1">Wählen Sie ein Formular oder ändern Sie den Filter.</p>
              </div>
            </div>
          </div>

          <!-- Speichern Button -->
          <div class="w-full mt-4">
            <button
                @click="editBaseArticle"
                data-ui="save-article"
                class="w-full rounded-md p-3 bg-trader-green hover:bg-trader-blue text-white font-medium transition-all duration-200 hover:shadow-lg transform hover:-translate-y-0.5"
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
    <Sidebar/>
  </div>
</template>
<script>
import Sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";
import {mutation, query} from "@/graphql";

export default {
  components: {CGoBack, Sidebar},
  data() {
    return {
      articleNumber: '',
      productId: 0,
      teamId: 0,
      baseArticle: null,
      fields: [],
      shoppingSections: [],
      searchTerm: '',
      showOnlyFilled: false,
      formularNames: [],
      selectedId: null,
      formular: [],
    }
  },
  computed: {
    filteredFields() {
      let filtered = this.fields;

      // Filter: Nur gefüllte Felder anzeigen
      if (this.showOnlyFilled) {
        filtered = filtered.filter(field =>
            field.fieldValue &&
            field.fieldValue.toString().trim() !== ''
        );
      }

      // Filter: Suchterm
      if (this.searchTerm && this.searchTerm.trim() !== '') {
        const searchLower = this.searchTerm.toLowerCase().trim();
        filtered = filtered.filter(field =>
            field.fieldName.toLowerCase().includes(searchLower) ||
            (field.fieldValue && field.fieldValue.toString().toLowerCase().includes(searchLower))
        );
      }

      return filtered;
    },
    filteredFormular() {
      let filtered = this.formular;

      // Filter: Nur gefüllte Felder anzeigen

      if (this.showOnlyFilled) {
        filtered = filtered.filter(form =>  form.fieldValue && form.fieldValue.toString().trim() !== ''  );
      }

      // Filter: Suchterm
      if (this.searchTerm && this.searchTerm.trim() !== '') {
        const searchLower = this.searchTerm.toLowerCase().trim();
        filtered = filtered.filter(form =>
            form.field.toLowerCase().includes(searchLower) ||
            form.label.toLowerCase().includes(searchLower) ||
            (form.fieldValue && form.fieldValue.toString().toLowerCase().includes(searchLower))
        );
      }
      return filtered;
    }
  },
  methods: {
    // Neue Methoden für die Suchfunktion
    toggleShowOnlyFilled() {
      this.showOnlyFilled = !this.showOnlyFilled;
    },

    async getProductFormularNames() {
      const [data, error] = await query.getFormularNames();
      if (error) {
        console.error("Fehler beim Abrufen der Formularnamen:", error.message);
        return;
      }
      this.formularNames = data;
    },

    clearSearch() {
      this.searchTerm = '';
      this.showOnlyFilled = false;
      this.selectedId = null;
    },

    // Bestehende Methoden
    goBack() {
      router.push("/administration")
    },

    async getFormularValue() {
      const [data, error] = await query.getFormularValue(this.selectedId, this.productId);
      if (error) {
        console.error("Fehler beim Abrufen der Formularnamen:", error.message);
        return;
      }
      console.log("Formular:", this.formular.length); // Debug-Ausgabe
      this.formular = data;
      console.log("Formular Data:", this.formular.length); // Debug-Ausgabe
    },

    async selectShoppingSections() {
      try {
        const [data, _] = await query.getPurchasers();
        this.shoppingSections = data;
      } catch (error) {
        console.error("Fehler beim Abrufen der ShoppingSections:", error.message);
      }
    },
    toggleButton(id) {
      this.selectedId = id;
      this.getFormularValue()
    },
    async editBaseArticle() {
      const baseArticleData = {
        productId: this.productId,
        teamId: this.teamId,
        articleNumber: this.articleNumber,
        fields: this.fields // Hier werden alle fields gesendet, nicht nur die gefilterten
      };
      try {
        const [data, error] = await mutation.editBaseArticle(baseArticleData);
        if (data.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Artikel gespeichert",
            message: "Der Artikel wurde gespeichert",
          });
        }
      } catch (error) {
        console.error("Daten konnten nicht geUpdatet werden ", error);
      }
    },

    async getBaseArticle() {
      try {
        const [data, error] =  await query.getBaseArticle(this.productId);
        this.baseArticle = data
        this.articleNumber = this.baseArticle.articleNumber
        this.teamId = this.baseArticle.teamId
        this.productId = this.baseArticle.productId
        this.fields = [];
        this.baseArticle.fields.forEach(field => {
          this.fields.push(field);
        });

      } catch (error) {
        console.error("Error in getBaseArticle:", error.message || error);
      }
    }
  },
  watch: {
    '$route.params.productId': function (newId, oldId) {
      this.productId = newId;
      this.getBaseArticle();
      this.selectShoppingSections();

    },
  },
  created() {
    if (this.$route.params.productId != null && typeof this.$route.params.productId != 'undefined' && this.$route.params.productId != '') {
      this.productId = this.$route.params.productId;
      this.getBaseArticle();
      this.selectShoppingSections();
      this.getProductFormularNames();
    }
    if (this.formularNames.length > 0) {
      this.selectedId = this.formularNames[0].id;
    }
  }
}
</script>
